<template>
  <div>
    <vs-icon
      bg="lightgray"
      class="ml-4 mt-2"
      @click="openModal"
      icon="tune"
      v-b-tooltip.hover.bottom="'Editar repositorio'"
    />
    <b-modal
      title="Editar repositorio"
      ref="editRepository"
      hide-footer
      centered
      size="lg"
      no-close-on-backdrop
      :hide-header-close="loading"
    >
      <form
        data-vv-scope="repository-form"
        autocomplete="off"
        @submit.prevent="editRepository"
      >
        <div class="row">
          <div class="col-12">
            <vs-input
              autocomplete="off"
              name="name"
              class="w-100"
              label="Nombre para repositorio"
              :disabled="reset"
              data-vv-as="nombre"
              v-model="name"
              v-validate="'required|max:255'"
              val-icon-danger="error_outline"
              :danger="errors.has('repository-form.name')"
              :danger-text="errors.first('repository-form.name')"
              val-icon-success="check_circle"
              :success="!errors.has('repository-form.name') && name.length > 0"
            />
          </div>
          <div class="col-12 mt-3">
            <vs-input
              autocomplete="off"
              name="description"
              class="w-100"
              label="Descripción"
              :disabled="reset"
              data-vv-as="descripción"
              v-model="description"
              v-validate="'max:255'"
              val-icon-danger="error_outline"
              :danger="errors.has('repository-form.description')"
              :danger-text="errors.first('repository-form.description')"
              val-icon-success="check_circle"
              :success="!errors.has('repository-form.description') && description.length > 0"
            />
          </div>
        </div>
        <div class="col-12 mt-3">
          <vs-checkbox
            class="ml-0"
            v-model="reset"
          >
            Reestablecer los nombres originales
          </vs-checkbox>
        </div>
        <div class="m-top-20 d-flex justify-end">
          <vs-button
            class="mt-5 ml-3"
            @click="editRepository"
            color="primary"
            type="border"
            :disabled="loading"
          >
            Editar
            <span v-show="loading" class="spinner-border spinner-border-sm text-white" />
          </vs-button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'EditRepository',
  data() {
    return {
      name: '',
      description: '',
      repositoryId: '',
      reset: false
    };
  },
  computed: {
    ...mapGetters('DocManagement', [
      'getRepositories',
      'loading'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ])
  },
  watch: {
    getRepositories() {
      this.populateFields();
    }
  },
  methods: {
    ...mapActions('DocManagement', [
      'editMainRepository',
      'loadRepositories'
    ]),
    openModal() {
      this.$refs.editRepository.show();
    },
    async editRepository() {
      const formCheck = await this.$validator.validateAll('repository-form');
      if (!formCheck) {
        return;
      }
      await this.editMainRepository({
        repositoryId: this.repositoryId,
        reset: this.reset ? 'si' : 'no',
        name: this.name,
        description: this.description,
      });
      await this.loadRepositories();
      this.$refs.editRepository.hide();
    },
    cleanFields() {
      this.name = '';
      this.description = '';
      this.repositoryId = '';
      this.reset = false;
    },
    populateFields() {
      const mainRepository = Object.values(this.getRepositories)[0];
      this.repositoryId = mainRepository.repositorioId;
      this.name = mainRepository.nombreRepositorio;
      this.description = mainRepository.descripcion;
      this.reset = false;
    }
  },
  async created() {
    this.cleanFields();
    await this.loadRepositories();
  }
};
</script>
